import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center mm-gradient-soft px-5">
      <div className="mm-card p-10 max-w-md w-full text-center mm-fade-up" data-testid="payment-cancel-card">
        <div className="text-5xl">🌿</div>
        <h1 className="text-2xl font-bold mt-4">Payment cancelled</h1>
        <p className="text-mm-muted mt-2">No worries — nothing was charged. Come back whenever you're ready.</p>
        <Link to="/paywall" className="mm-btn mt-6" data-testid="payment-cancel-retry">Try again</Link>
      </div>
    </div>
  );
}
